import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login';
import SignUp from './components/SignUp';
import HomePage from './components/HomePage';
import MyOrders from './components/MyOrders';
import AccountDashboard from './components/AccountDashboard';
import AdminDashboard from './admin/AdminDashboard';
import ManageUsers from './admin/ManageUsers';
import ManageProducts from './admin/ManageProducts';
import ManageOrders from './admin/ManageOrders';
import Reports from './admin/Reports';
import AdminProfile from './admin/AdminProfile';
import ManageEnterpriseInquiries from './admin/ManageEnterpriseInquiries';
import ManageSubscribers from './admin/ManageSubscribers';
import EmailCampaigns from './admin/EmailCampaigns';
import ViewAllProducts from './components/ViewAllProducts';
import AdminReviews from './admin/AdminReviews';
import UserDashboard from './components/UserDashboard';
import ProductDetails from './components/ProductDetails';
import ContactPage from './components/ContactPage';
import ManageContactQueries from './admin/ManageContactQueries';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!sessionStorage.getItem('scrollTarget')) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function AppContent() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAccountDashboard, setShowAccountDashboard] = useState(false);
  const [showOrders, setShowOrders] = useState(false);
  const [openOrdersInDashboard, setOpenOrdersInDashboard] = useState(false);
  const [triggerCartOpen, setTriggerCartOpen] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) setUser(JSON.parse(storedUser));
    setLoading(false);
  }, []);

  useEffect(() => {
    const handler = () => { setOpenOrdersInDashboard(false); setShowAccountDashboard(true); };
    window.addEventListener('openAccountDashboard', handler);
    return () => window.removeEventListener('openAccountDashboard', handler);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login';
  };

  useEffect(() => {
    const handler = () => setShowPrivacyPolicy(true);
    window.addEventListener('openPrivacyPolicy', handler);
    return () => window.removeEventListener('openPrivacyPolicy', handler);
  }, []);

  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup';

  if (loading) return null;

  return (
    <>
      <ScrollToTop />
      {!location.pathname.startsWith('/admin') && location.pathname !== '/products' && location.pathname !== '/contact' && (
        <HomePage
          user={user}
          onLogout={handleLogout}
          onShowOrders={() => { setOpenOrdersInDashboard(true); setShowAccountDashboard(true); }}
          onShowAccountDashboard={() => { setOpenOrdersInDashboard(false); setShowAccountDashboard(true); }}
          triggerCartOpen={triggerCartOpen}
          onCartOpened={() => setTriggerCartOpen(false)}
        />
      )}
      {isAuthPage && (
        location.pathname === '/login' ? <Login /> : <SignUp />
      )}
      {showAccountDashboard && (
        <AccountDashboard
          user={user}
          onClose={() => { setShowAccountDashboard(false); setOpenOrdersInDashboard(false); }}
          onShowOrders={() => { setShowAccountDashboard(false); setShowOrders(true); }}
          onCartClick={() => { setShowAccountDashboard(false); setTriggerCartOpen(true); }}
          openOrders={openOrdersInDashboard}
        />
      )}
      {showOrders && (
        <MyOrders user={user} onClose={() => setShowOrders(false)} />
      )}
      {showPrivacyPolicy && (
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
      )}
      <Routes>
        <Route path="/products" element={<ViewAllProducts user={user} onLogout={handleLogout} onShowAccountDashboard={() => setShowAccountDashboard(true)} />} />
        <Route path="/contact" element={<ContactPage user={user} onLogout={handleLogout} onCartClick={() => setTriggerCartOpen(true)} onShowOrders={() => { setShowOrders(true); }} onShowAccountDashboard={() => setShowAccountDashboard(true)} onProductClick={() => {}} />} />
        <Route path="/admin" element={user?.role === 'ADMIN' ? <AdminDashboard /> : <Navigate to="/login" />} />
        <Route path="/admin/users" element={user?.role === 'ADMIN' ? <ManageUsers /> : <Navigate to="/login" />} />
        <Route path="/admin/products" element={user?.role === 'ADMIN' ? <ManageProducts /> : <Navigate to="/login" />} />
        <Route path="/admin/orders" element={user?.role === 'ADMIN' ? <ManageOrders /> : <Navigate to="/login" />} />
        <Route path="/admin/enterprise" element={user?.role === 'ADMIN' ? <ManageEnterpriseInquiries /> : <Navigate to="/login" />} />
        <Route path="/admin/subscribers" element={user?.role === 'ADMIN' ? <ManageSubscribers /> : <Navigate to="/login" />} />
        <Route path="/admin/email-campaigns" element={user?.role === 'ADMIN' ? <EmailCampaigns /> : <Navigate to="/login" />} />
        <Route path="/admin/reviews" element={user?.role === 'ADMIN' ? <AdminReviews /> : <Navigate to="/login" />} />
        <Route path="/admin/reports" element={user?.role === 'ADMIN' ? <Reports /> : <Navigate to="/login" />} />
        <Route path="/admin/contact-queries" element={user?.role === 'ADMIN' ? <ManageContactQueries /> : <Navigate to="/login" />} />
        <Route path="/admin/profile" element={user?.role === 'ADMIN' ? <AdminProfile /> : <Navigate to="/login" />} />
        <Route path="/" element={null} />
        <Route path="/login" element={null} />
        <Route path="/signup" element={null} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
